import React, { useState, useEffect } from "react";
import { scroller } from "react-scroll";
import { useNavigate, useLocation } from "react-router-dom";
import LogoImage from "./Assets/htlogo.png";
import LogoImages from "./Assets/htlogosmall.png"; 

const Navbar = ({ hideNavbar }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [scrollTarget, setScrollTarget] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/" && scrollTarget) {
      const timer = setTimeout(() => {
        scroller.scrollTo(scrollTarget, { smooth: true, duration: 600 });
        setScrollTarget(null);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [location.pathname, scrollTarget]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const checkWidth = () => setIsMobile(window.innerWidth <= 768);
    checkWidth();
    window.addEventListener("resize", checkWidth);
    return () => window.removeEventListener("resize", checkWidth);
  }, []);

  const hidePaths = [
    "/dashboard",
    "/dashboard/owner",
    "/dashboard/admin",
    "/dashboard/blogger",
    "/owner",
    "/admin",
    "/blogger",
  ];

  const hide =
    hideNavbar ||
    hidePaths.some((p) => location.pathname.toLowerCase().startsWith(p));

  if (hide) return null;

  // Menu
  const menuScroll = [
    { to: "home", label: "Home" },
    { to: "contact", label: "Contact" },
  ];

  const menuRoute = [
    { path: "/blog", label: "Blog" },
    { path: "/event", label: "Event" },
  ];

  const gotoScroll = (target) => {
    if (location.pathname !== "/") {
      setScrollTarget(target);
      navigate("/");
    } else {
      scroller.scrollTo(target, { smooth: true, duration: 600 });
    }
    setIsMenuOpen(false);
  };

  const gotoPage = (path) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  const gotoHome = () => {
    navigate("/");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <nav
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: isMobile ? "6px 20px" : "8px 40px",
        background: scrolled ? "rgba(255, 255, 255, 0.25)" : "#fff",
        backdropFilter: scrolled ? "blur(10px) saturate(150%)" : "none",
        borderBottom: scrolled ? "1px solid rgba(255, 255, 255, 0.3)" : "none",
        position: "sticky",
        top: 0,
        zIndex: 2000,
        transition: "all 0.3s ease-in-out",
        height: scrolled ? "70px" : "120px",
      }}
    >
      <img
        src={scrolled ? LogoImages : LogoImage}
        alt="Logo"
        onClick={gotoHome}
        style={{
          height: isMobile
            ? scrolled
              ? "30px"
              : "400px"
            : scrolled
            ? "50px"
            : "100px",
          width: isMobile
            ? scrolled
              ? "160px"
              : "250px"
            : scrolled
            ? "250px"
            : "580px",
          objectFit: "contain",
          cursor: "pointer",
          transition: "all 0.3s ease-in-out",
        }}
      />

      {!isMobile && (
        <ul
          style={{ display: "flex", gap: "30px", listStyle: "none", margin: 0 }}
        >
          {menuScroll.map((m) => (
            <li key={m.to}>
              <span
                style={{
                  cursor: "pointer",
                  fontWeight: 600,
                  fontSize: "16px",
                  color: "#060f6d",
                }}
                onClick={() => gotoScroll(m.to)}
              >
                {m.label}
              </span>
            </li>
          ))}
          {menuRoute.map((m) => (
            <li key={m.path}>
              <span
                style={{
                  cursor: "pointer",
                  fontWeight: 600,
                  fontSize: "16px",
                  color: "#060f6d",
                }}
                onClick={() => gotoPage(m.path)}
              >
                {m.label}
              </span>
            </li>
          ))}
        </ul>
      )}

      {isMobile && (
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          style={{ background: "none", fontSize: "26px", border: "none" }}
        >
          {isMenuOpen ? "✕" : "☰"}
        </button>
      )}

      {isMobile && isMenuOpen && (
        <ul
          style={{
            position: "absolute",
            top: "100%",
            right: "10px",
            background: "#fff",
            padding: "15px",
            borderRadius: "12px",
            width: "150px",
            listStyle: "none",
          }}
        >
          {menuScroll.map((m) => (
            <li key={m.to}>
              <span
                onClick={() => gotoScroll(m.to)}
                style={{
                  display: "block",
                  padding: "12px 0",
                  borderBottom: "1px solid #ddd",
                  textAlign: "center",
                  fontWeight: 600,
                }}
              >
                {m.label}
              </span>
            </li>
          ))}

          {menuRoute.map((m) => (
            <li key={m.path}>
              <span
                onClick={() => gotoPage(m.path)}
                style={{
                  display: "block",
                  padding: "12px 0",
                  borderBottom: "1px solid #ddd",
                  textAlign: "center",
                  fontWeight: 600,
                }}
              >
                {m.label}
              </span>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
};

export default Navbar;
